<template>
  <div>
    <transition name="router-anim" v-if="visible == 0">
      <div class="kits">
        <div class="top-panel">
          <DescriptionModal class="description-modal" 
            :description="`This page displays a list of customers.`" />
          <div class="prob-count custom" v-if="filter_count == 0">
            Total: {{ report.total }}
          </div>
          <div class="prob-count custom" v-else>
            Subtotal: {{ report.total }}
          </div>
        </div>
        <div class="kits-title">
          <div class="title first-name">
            FIRST NAME
          </div>
          <div class="title last-name">
            LAST NAME
          </div>
          <div class="title email">
            EMAIL
          </div>
          <div class="title kit-count">
            KITS COUNT
          </div>
          <div class="title date" @click="sortedBy">
            REGISTRATION DATE
            <img
              src="../../images/dashboard/up.png"
              alt="#"
              v-if="sortedByState === 'desc'"
            />
            <img
              class="down"
              src="../../images/dashboard/up.png"
              alt="#"
              v-else
            />
          </div>
        </div>
        <div v-if="customers.length > 0">
          <div class="kits-item" v-for="item in customers">
            <div
              class="kit-desc first-name"
              @click="
                kits(item.testkits)
              "
            >
              {{ item.first_name }}
            </div>
            <div class="kit-desc last-name">
              {{ item.last_name }}
            </div>
            <div class="kit-desc email">
              <span>{{ item.email }}</span>
            </div>
            <div class="kit-desc kit-count">
              <span>{{ item.testkits.length }}</span>
            </div>
            <div class="kit-desc date">
              {{ date(item.created_at) }}
            </div>
            <div
            class=" kit-desc  edit-kit-btn"
            @click="edit(item)"
            title="Edit"
          >
            <img
              src="../../images/dashboard/icons8-edit-100.png"
            />
          </div>
          <div
            class="login-kit-btn"
            @click="login(item)"
          >
          <img
              src="../../images/dashboard/login.svg"
              alt="#"
            />
          </div>
          </div>
        </div>
        <div v-else class="kits-item">
          <div class="kit-desc nodata">
            No Data Retrieved.
          </div>
        </div>
        <div class="pogination">
          <Paginate
            v-if="count_page > 1"
            :page-count="count_page"
            :page-class="'pogination-item'"
            :click-handler="changePage"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pogination-wrap'"
          ></Paginate>
        </div>
      </div>
    </transition>
    <transition name="router-anim">
      <customerKit 
        v-if="visible == 1"
        :userkits="userkits"
        @showModal="showModal">
      </customerKit>
    </transition>
    <Modal v-if="modal" @closeModal="closeModal"></Modal>
  </div>
</template>
  
<script>
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
import Paginate from "vuejs-paginate";
import Remove from "../../images/dashboard/Remove";
import customerKit from "./customers/customerKit";
import Modal from "../dashboard/Modal";
  
export default {
  name: "Customers",
  data() {
    return {
      customers: [],
      userkits:null,
      count_page: 1,
      sortedByState: "desc",
      visible:0,
      sub_total: 0,
      modal: false,
      report: {
        total: 0
      },
      sub_total: 0,
      filter_count: 0
    };
  },
  components: {
    Remove,
    Paginate,
    customerKit,
    Modal,
  },
  methods: {
    ...mapActions([
      "setAdminPginationPage",
      "getContactCustomers",
      "setSortedByAdmin",
      'setCustomerkit'
    ]),
    edit(item){
      this.$emit("editCusKit", { show: true, item: item});
    },
    changePage(item) {
      this.setAdminPginationPage(item).then(() => {
        this.getContactCustomers(null);
      });
    },
    sortedBy() {
      if(this.sortedByState === "desc") {
        this.sortedByState = "asc";
      }else {
        this.sortedByState = "desc";
      }

      this.setSortedByAdmin(this.sortedByState).then(() => {
        this.getContactCustomers(null);
      });
    },
    remove(id, firstName, lustName) {
      this.$emit("confirmDelLabOps", {
        show: true,
        id,
        fullname: `${firstName} ${lustName}`
      });
    },
    date(localDate) {
      return localDate;
      // if (localDate) {
      //   let date = new Date(localDate);
      //   return moment(date).format("MM/DD/YYYY");
      // }
    },
    kits(testkits) {
      this.setCustomerkit(1);
      this.visible = 1;
      this.userkits = testkits;
    },
    showModal(boolean) {
      this.modal = boolean;
    },
    closeModal(boolean) {
      this.modal = boolean;
    },
    login(user) {
      this.$emit("confirmCusLogin", { show: true, user:user});
    },
  },
  computed: {
    ...mapGetters(["getCustomers","adminPogination","customersTotal","getCustomerkit"])
  },
  watch: {
    adminPogination(num) {
      this.count_page = num;
    },
    getCustomers(obj) {
      this.customers = obj;
      this.visible = 0;
      this.report.total = Number(this.$store.getters.customersTotal);
      this.sub_total = Number(this.$store.getters.customersSubTotal);
      this.filter_count = Number(this.$store.getters.customersCount);
      this.setCustomerkit(0);	
    },
    getCustomerkit(num){
      this.visible = num;
    }
  },
  mounted() {
    this.setCustomerkit(0);
    this.customers = this.$store.getters.getCustomers;
    if(this.$store.getters.getCustomers != null) {
      this.report.total = Number(this.$store.getters.customersTotal);
    }
    if (this.$store.getters.adminPogination !== null) {
      this.count_page = this.$store.getters.adminPogination;
    }
    this.sub_total = Number(this.$store.getters.customersSubTotal);
    this.filter_count = Number(this.$store.getters.customersCount);
  }
};
</script>
  
<style scoped>
.title.date .down {
  transform: rotate(180deg);
}
.kits {
  margin: 20px 0 0 0;
}
.kits-title {
  display: flex;
  justify-content: space-between;
  margin: 0 0 30px 0;
  padding: 0 30px;
}
.title {
  color: #b3b3b3;
  font-size: 14px;
  font-family: TTNormsMedium, sans-serif;
}
.title.first-name {
  min-width: 230px;
  width: 100%;
}
.kit-desc.first-name {
  min-width: 230px;
  width: 100%;
  cursor: pointer;
}
.kit-desc.first-name:hover {
  color: #005eb8;
  font-family: TTNormsRegular, sans-serif;
}
.title.last-name {
  min-width: 230px;
  width: 100%;
}
.kit-desc.last-name {
  min-width: 230px;
  width: 100%;
}
.title.kit-count {
  min-width: 200px;
  width: 100%;
}
.kit-desc.kit-count {
  min-width: 200px;
  width: 100%;
}
.title.email {
  min-width: 300px;
  width: 100%;
}
.kit-desc.email {
  min-width: 300px;
  width: 100%;
}
.kit-desc.email span {
  overflow: hidden;
  width: 98%;
  display: inline-block;
}
.title.date {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  width: 100%;
  position: relative;
  cursor: pointer;
}
.title.date img {
  margin-top: -2px;
  max-width: 7px;
  height: 14px; 
}
.kit-desc.date {
  padding: 0 20px 0 0;
  min-width: 70px;
  width: 100%;
}
.kits-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px;
  background-color: #fff;
  margin: 10px 0;
  border-radius: 5px;
}
.kits-item:hover {
  background-color: #e0e9f4;
}
.kit-desc {
  color: #58595b;
  font-size: 14px;
  font-family: TTNormsLight, sans-serif;
}
.remove-icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background-color: transparent;
  border: none;
  outline: none;
  width: 10px;
}
.pogination {
  margin: 20px 0 0 0;
}
.title.result .down {
  transform: rotate(180deg);
}
.prob-count {
  text-align: right;
  color: #58595b;
  font-family: TTNormsLight, sans-serif;
  font-size: 13px;
  font-weight: bold;
}
.prob-count.custom {
  margin-bottom: 20px;
}
.kit-desc.nodata {
  width: 100%;
  overflow: hidden;
  display: inline-block;
  text-align: center;
}

.kits-item:hover .edit-kit-btn {
  display: block;
  padding-right: 6px;
}
.edit-kit-btn {
  display: none;
  cursor: pointer;
}

.edit-kit-btn img{
  width: 20px;
}

.kits-item:hover .login-kit-btn {
  display: block;
  margin-right: -8px;
}
.login-kit-btn {
  display: none;
  cursor: pointer;
}
.login-kit-btn img{
  width: 25px;
}
.top-panel {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  margin-top: 30px;
}
</style>
  